import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChanges: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="changes, plus-minus, compare"><path d="M8.5 10.5H15.5M12 7V14" stroke="currentColor" strokeWidth="1.5"/><path d="M8.5 16L15.5 16" stroke="currentColor" strokeWidth="1.5"/><path d="M20.25 20.25V3.75H3.75V20.25H20.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
};

export default IconChanges;
